export default {
  ru: "RU",
  en: "EN",
  CoursesTitle: "Courses | " + process.env.VUE_APP_INSTALL_NAME + "",
  Module_AI: {
    title: "AI",
    desc: "AI services for medical imaging",
  },
  Module_edu: {
    title: "Education",
    desc: "Diagnostic simulators and courses for doctors",
  },
  Module_community: {
    title: "Community",
    desc: "Knowledge sharing between doctors on clinical cases",
  },
  Profile: "Profile",
  Subscription: "Subscription",
  "Go to site": "Website",
  "Access after pay": "Lesson is closed",
  Exit: "Log Out",
  MY: "MY",
  Home: "Home",
  "Mobile banner text : demo":
    "Create an account and get full access to AI services and simulators",
  Platform: "PLATFORM FOR DOCTORS",
  "Platform info":
    "AI assistants, diagnostic simulators and courses for your continuous growth",
  "Download app": "Download Android app",
  "Home title": "Home | " + process.env.VUE_APP_INSTALL_NAME + "",
  AI: "AI",
  edu: "Education",
  community: "Community",
  "Your courses": "Your Courses",
  "Recomended courses": "Recommended Courses",
  Courses: "Courses",
  Calculator: "Calculator",
  Plug: "Integration",
  "Go to": "Go",
  Case: "Case",
  Cases: "Cases",
  "Case success": "Completed",
  "Case unsuccess": "Not Completed",
  Modality: "Modality",
  "Page title tail": " | " + process.env.VUE_APP_INSTALL_NAME + "",
  "Cant find service?": "Need another service?",
  "Text us": "Text us",
  "I need AI for...": "I need AI for...",
  "Thx for reply": "Thank you for the feedback!",
  Send: "Send",
  Sent: "Sent",
  "Cannot loading reply -- adblock":
    "Request failed. Please disable browser extensions such as VPN and Adblocker.",
  Favorites: "Favorites",
  "Cases about 1": "Add your case",
  "Cases about 2":
    "Share a clinical case in DICOM format and get colleagues' opinions.",
  "Cases about 3": "How do we anonymize and protect data?",
  "Add case": "Add Case",

  All: "All",
  "I upload": "Upload",
  drafts: "Drafts",
  draft: "Draft",
  "Case v2": "Case",
  "Open study": "Open Study",
  Comments: "Comments",
  "Comment placeholder": "Add comment...",
  "Favorites about 1": "Nothing here yet, click on the icon",
  "Favorites about 2": "on an interesting case to add it to favorites",
  "Comment screen info 1": "To attach a screenshot, ",
  "Comment screen info 2": "open the study in the viewer",
  Download: "Download",
  "Record Date": "Lecture Recording",
  "Request a course": "Join",
  "Request a course doned": "You have left a request",
  "Forgot password?": "Forgot Password?",
  "Reset password": "Reset Password",
  "Reset password v2": "Reset Password",
  "Reset password about":
    "Enter the email address you used to register. We will send you instructions to reset your password",
  "Reset password about after":
    "A password reset link has been sent to your email",
  "Back to prev page": "Back",
  Email: "Email",
  "Not valid email": "Invalid email",
  "Not found email": "Email not registered",
  EmailAlreadyRegistered: "Email already registered",
  NotActivatedAccount: "Not Activated Account",
  "Back to login": "Back to Login",
  "Email not come?": "Didn't receive the email?",
  "Write to support": "Contact Support",
  "Create new password": "Create a New Password",
  "Password confirm": "Confirm Password",
  "Min 8": "At least 8 characters",
  "Two inputs don't match!": "Passwords do not match",
  "Update password": "Update Password",
  "Password updated": "Password Updated",
  "Invalid password token": "Invalid link, please try again",
  "Unknown user": "Unknown User",
  "Attach image": "Attach Image",
  Remove: "Remove",
  Complain: "Report",
  "Complain sent": "Your report has been successfully sent",
  owner: "Owner",
  assistant: "Curator",
  "Answers 1": "answer",
  "Answers 2": "answers",
  "Answers 3": "answers",
  "Add answer": "Reply",
  "Collapse answers": "Collapse",
  "Image only": "<Image>",
  "Cannot upload from mobile":
    "You can download studies in DICOM format from desktop",
  "Password rule": "Type at least 8 symbols, 1 letter and 1 number",
  ReferenceCursors: "C - Reference Cursors",
  "bad browser for mpr":
    "MPR (may not be available) We recommend opening the site in the latest version of Google Chrome browser",
  "Service in process": "Upload is unavailable",
  "Service in process about":
    "However, you can learn the functionality of the service using the demo studies. We will let you know when you can process your study.",
  "Edit case": "Edit case",
  Title: "Title",
  "Access count": "Available",
  "Access count about":
    "If you select the option 'Everyone', the publication will be visible to everyone. If you select 'By link', you can only see it by clicking on the direct link from the 'Share' button.",
  "To All": "Everyone",
  "To Link": "By link",
  Publish: "Publish",
  "Publish about":
    "When publishing anonymously, your name and company will not be visible to other users.",
  How: "How",
  "As Anon": "Anonymous",
  "Case accept": "I do not post any personal data of the patient. ",
  "User Policy": "Privacy Policy",
  "Remove case": "Delete case",
  "Save draft": "Save draft",
  "Remove case success": "The case was successfully deleted",
  "Remove case error": "The case could not be deleted. Try again later",
  "Update case error": "The case could not be updated. Try again later",
  Edit: "Edit",
  "Cases v2": "Cases",
  sec: " sec",
  "Confirm accept": "Confirm accept",
  "Remove case?": "Remove serie?",
  "Upload AI": "Upload a study in DICOM format",
  "Upload edu": "Upload a case in DICOM, jpeg or png format",
  "Upload community": "Upload a case in DICOM, jpeg or png format",
  "As anon": "Anonymous",
  status: {
    free: "Free",
    subscription: "Subscription",
    draft: "Draft",
  },
  noAcceptResult: "Describe what you disagree with",
  Meta: {
    tail: "%s | " + process.env.VUE_APP_INSTALL_NAME + "",
    tail2: " | " + process.env.VUE_APP_INSTALL_NAME + "",
    default: {
      title: "Platform for Doctors",
      desc: "Online medical platform: a community of doctors, AI assistants, diagnostic training tools, courses, and useful resources.",
    },

    "community-cases": {
      title: "Medical Community",
      desc: "Professional online community of doctors - discussing interesting cases, questions, and sharing experiences!",
    },
    home: {
      title: "Platform for Doctors",
      desc: "Online medical platform: AI assistants, diagnostic training tools, courses, and useful resources for doctors.",
    },
    "ai-services": {
      title: "AI Services",
      desc: "Artificial intelligence services for disease diagnosis.",
    },
    "edu-services": {
      title: "Educational Platform for Doctors",
      desc: "List of training courses and a knowledge base for diagnostic doctors.",
    },
  },
  "Video is unavailable": "Video is unavailable",
  Licence:
    "© 2025 " +
    process.env.VUE_APP_INSTALL_NAME +
    " Platform Limited Liability Company, INN 7714420229, OGRN 5177746328106, all rights reserved. 121205, Moscow, Skolkovo Innovation Center Territory, Nobel St. 7, 2nd floor, room 37, work 2",
  "Policy v2": "Personal Data Processing and Protection Policy",
  "Site company": "Company website",
  homepage: {
    connect: "Connect for ",
    cost: "/month",
    goToAI: "Process studies",
    notAuth: {
      title: "Unlock all AI assistant capabilities",
      desc: "Get access to the AI assistant for automated measurements and report generation",
    },
    notAuthSub__off: {
      title: "Unlock all AI assistant capabilities",
      desc: "Get access to the AI assistant for automated measurements and report generation",
    },
    notAuthSub__on: {
      title: "AI services for medical image analysis",
      desc: "Automates measurements and generates a study report. Process 3 studies for free, then — more for <PRICE>",
    },
    baseSub: {
      title: "Eliminate routine in research analysis with AI",
      desc: "AI assistant automates measurements and generates reports in 1 click",
    },
    notBaseSub: {
      title: "Upload a scan in 1 click",
      desc: "Use AI assistant to automate<br> measurements and generate reports",
    },
  },
  "Start type": "Start typing...",
  buy: "Buy",
  more_details: "More details",
};
